// Exported in the order they mount on the homepage. GlobalImpactSection is
// dropped from the new IA; it and its WorldMap dependency were deleted by
// #7921. FeaturedWorkSection and LatestInsightsSection are deleted by #7919.
export { default as HeroSection } from './HeroSection';
export { default as ClientLogoStrip } from './ClientLogoStrip';
export { default as ProblemSection } from './ProblemSection';
export { default as FounderSection } from './FounderSection';
export { default as ServicesSection } from './ServicesSection';
export { default as FrameworkSection } from './FrameworkSection';
export { default as ImpactGallerySection } from './ImpactGallerySection';
export { default as Footer } from './Footer';
